<template>
  <div v-if="matches.length" class="fd-backdrop" @click.self="$emit('cancel')">
    <div class="fd-dialog" role="dialog" aria-modal="true" aria-labelledby="fd-title">
      <div class="fd-head">
        <div>
          <h5 id="fd-title" class="mb-0"><i class="fe fe-alert-triangle text-warning mr-1"></i>
            {{ likely ? "This facility may already exist" : "Similar facilities found" }}</h5>
          <small class="text-muted">Facilities in your state that match "{{ name }}". Use the existing one instead of adding a duplicate.</small>
        </div>
        <button class="btn btn-sm btn-link text-secondary" @click="$emit('cancel')" aria-label="Close"><i class="fe fe-x"></i></button>
      </div>
      <div class="fd-body">
        <div v-for="m in matches" :key="m.id" class="fd-item" :class="m.level">
          <div class="d-flex flex-wrap align-items-start" style="gap: 8px;">
            <div class="flex-grow-1">
              <div class="font-weight-bold">{{ m.agency_name }}</div>
              <div class="small text-muted">
                {{ [m.lga, m.ward].filter(Boolean).join(" · ") || "LGA not set" }}
                <span v-if="m.phc_type"> · {{ m.phc_type }}</span><span v-if="m.phc_general"> · {{ m.phc_general }}</span>
              </div>
              <div class="small text-muted">
                <span v-if="m.facility_code">Code {{ m.facility_code }} · </span><span v-if="m.phone_number">{{ m.phone_number }} · </span><span v-if="m.email">{{ m.email }}</span>
              </div>
              <div class="mt-1">
                <span v-for="r in m.reasons" :key="r" class="fd-reason">{{ r }}</span>
              </div>
            </div>
            <div class="text-right">
              <span class="fd-level" :class="m.level">{{ m.level === "likely" ? "Likely duplicate" : "Possible match" }}</span>
              <div class="mt-2 d-flex flex-wrap justify-content-end" style="gap: 6px;">
                <a v-if="m.linked_to_agency" :href="'/provider-' + m.id" target="_blank" class="btn btn-sm btn-outline-primary"><i class="fe fe-eye mr-1"></i> Open</a>
                <template v-else>
                  <span class="small text-muted align-self-center">Not linked to your agency</span>
                  <button class="btn btn-sm btn-primary" :disabled="busy" @click="$emit('link', m)"><i class="fe fe-link mr-1"></i> Link to my agency</button>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fd-foot">
        <small class="text-muted mr-auto">Only add it if it is a different facility.</small>
        <button class="btn btn-sm btn-outline-secondary" :disabled="busy" @click="$emit('cancel')">Go back</button>
        <button class="btn btn-sm btn-outline-danger" :disabled="busy" @click="$emit('add-anyway')">Add as a new facility anyway</button>
      </div>
    </div>
  </div>
</template>

<script>
/** Likely duplicates of a facility being added (POST providers/duplicate-check); the parent decides what each button does. */
export default {
  name: "FacilityDuplicateModal",
  props: {
    matches: { type: Array, default: () => [] },
    likely: { type: Number, default: 0 },
    name: { type: String, default: "" },
    busy: { type: Boolean, default: false },
  },
};
</script>

<style scoped>
.fd-backdrop { position: fixed; inset: 0; background: rgba(15, 23, 42, 0.45); z-index: 1060; display: flex; align-items: flex-start; justify-content: center; padding: 48px 16px; overflow-y: auto; }
.fd-dialog { background: #fff; border-radius: 12px; width: 100%; max-width: 680px; box-shadow: 0 20px 50px rgba(15, 23, 42, 0.25); }
.fd-head { display: flex; justify-content: space-between; align-items: flex-start; padding: 18px 20px 12px; border-bottom: 1px solid #e2e8f0; }
.fd-body { padding: 12px 20px; max-height: 60vh; overflow-y: auto; }
.fd-item { border: 1px solid #e2e8f0; border-radius: 10px; padding: 12px 14px; margin-bottom: 10px; }
.fd-item.likely { border-color: #fca5a5; background: #fff7f7; }
.fd-reason { display: inline-block; font-size: 0.72rem; background: #f1f5f9; color: #334155; border-radius: 999px; padding: 2px 8px; margin: 0 4px 4px 0; }
.fd-level { font-size: 0.72rem; font-weight: 600; border-radius: 999px; padding: 3px 10px; white-space: nowrap; }
.fd-level.likely { background: #fee2e2; color: #991b1b; }
.fd-level.possible { background: #fef3c7; color: #92400e; }
.fd-foot { display: flex; align-items: center; gap: 8px; padding: 12px 20px; border-top: 1px solid #e2e8f0; }
</style>
